import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add schedule API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  addSchedule: (data: any): Promise<any> => {
    return postRequest(`${config.commonApiUrl}api/facility/v1/charging-schedule`, data, false);
  },
  /**
   * Fetch schedule API
   * @param query
   */
  fetchSchedules: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-schedule`, {
      ...parameters,
    });
  },
  /**
   * Fetch schedule API for export
   * @param query
   */
  fetchSchedulesExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-schedule/export-data`, {
      ...parameters,
    });
  },
  /**
   * Edit schedule API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editSchedule: (id: number | string | null, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/facility/v1/charging-schedule/${id}`,
      data,
      false,
    );
  },

  /**
   * Fetch approved station API
   * @returns 
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-schedule/list-filters`);
  },
};
